import { Component } from '@angular/core';
import { BulkActionFormComponent } from '../MonitoringBulkActionDialog/bulk-action-form.component';

@Component({
    selector: 'agpr-bulk-action-form-blank',
    templateUrl: './bulk-action-form-blank.component.html',
    standalone: false
})
export class BulkActionFormBlankComponent extends BulkActionFormComponent {
    writeValue(): void {
    }
}
